import { createAction, props } from '@ngrx/store';
import { RequestsOverviewModel } from 'src/app/dashboard/components/overview/models/overview.model';
import { PageAndSize } from 'src/app/dashboard/components/overview/models/paginated-overview.model';
import { ManureOfferModel } from 'src/app/offer/models/manure-offer.model';
import { ManureRequestModel } from 'src/app/request/models/manure-request.model';

export const switchToMyManureOffers = createAction(
  '[My Advertisements] Switch view to Manure Offers table',
);

export const switchToMyManureRequests = createAction(
  '[My Advertisements] Switch view to Manure Requests table',
);

export const loadActiveOffers = createAction(
  '[Active Offers][My Advertisements] Load active offers',
  props<{ paginationOptions: PageAndSize }>(),
);

export const loadActiveOffersSuccess = createAction(
  '[Active Offers][My Advertisements] Load active offers success',
  props<{ activeOffersList: ManureOfferModel[]; totalNumberOfActiveOffers: number }>(),
);

export const loadActiveOffersFailure = createAction(
  '[Active Offers My Advertisements] Load active offers failure',
  props<{ error: string }>(),
);

export const loadClosedOffers = createAction(
  '[Closed Deals Offers][My Advertisements] Load close offers',
  props<{ paginationOptions: PageAndSize }>(),
);

export const loadClosedOffersSuccess = createAction(
  '[Closed Deals Offers][My Advertisements] Load closed offers success',
  props<{ closedDealsOffersList: ManureOfferModel[] }>(),
);

export const loadClosedOffersFailure = createAction(
  '[Closed Deals Offers][My Advertisements] Load closed offers failure',
  props<{ error: string }>(),
);

export const loadActiveRequests = createAction(
  '[Active Requests][My Advertisements] Load active requests',
  props<{ pageAndSize: PageAndSize }>(),
);

export const loadActiveRequestsSuccess = createAction(
  '[Active Requests][My Advertisements] Load active requests success',
  props<{ activeRequestsList: ManureRequestModel[]; totalNumberOfActiveRequests: number }>(),
);

export const loadActiveRequestsFailure = createAction(
  '[Active Requests] Load active requests failure',
  props<{ error: string }>(),
);

export const loadClosedRequests = createAction(
  '[Closed Requests][My Advertisements] Load closed requests',
  props<{ paginationOptions: PageAndSize }>(),
);

export const loadClosedRequestsSuccess = createAction(
  '[Closed Requests][My Advertisements] Load closed requests success',
  props<{ closedRequestsList: ManureRequestModel[] }>(),
);

export const loadClosedRequestsFailure = createAction(
  '[Closed Requests] Load closed requests failure',
  props<{ error: string }>(),
);

export const openActiveRequestDialog = createAction(
  '[My Advertisements] Open active request overview slide-in dialog',
  props<{ selectedRequest?: RequestsOverviewModel }>(),
);

export const openActiveRequestDialogSuccess = createAction(
  '[My Advertisements] Open active request overview slide-in dialog success',
);

export const acceptMatch = createAction(
  '[Requests][My Advertisements] Accept match on my selected active request',
  props<{ requestId: number }>(),
);

export const acceptMatchSuccess = createAction(
  '[Requests][My Advertisements] Accept match on my selected active request success',
  props<{ response: RequestsOverviewModel }>(),
);

export const rejectMatch = createAction(
  '[Requests][My Advertisements] Reject match on my selected active request',
  props<{ requestId: number }>(),
);

export const rejectMatchSuccess = createAction(
  '[Requests][My Advertisements] Reject match on my selected active requests success',
  props<{ response: RequestsOverviewModel }>(),
);

export const deleteOffer = createAction(
  '[Active Offers][My Advertisements] Delete offer',
  props<{ id: number }>(),
);

export const deleteOfferSuccess = createAction(
  '[Active Offers][My Advertisements] Delete offer success',
  props<{ id: number }>(),
);

export const deleteOfferFailure = createAction(
  '[Active Offers][My Advertisements] Delete offer failure',
);

export const deleteRequest = createAction(
  '[Active Requests][My Advertisements] Delete request',
  props<{ id: number }>(),
);

export const deleteRequestSuccess = createAction(
  '[Active Requests][My Advertisements] Delete request success',
  props<{ id: number }>(),
);

export const deleteRequestFailure = createAction(
  '[Active Requests][My Advertisements] Delete request failure',
);
